const AntiStop = [
  '学校', '小学', '中学', '大学', '学院', '医院', '卫生院', '公司', '法院', '中院', '高院', '检察院', '研究所', '事务所', '村委会', '居委会', '市委', '党组', '政法委', '组织部', '人大', '常委', '常务委员会', '政协', '政治', '协商', '纪委', '纪检委', '宣传部', '统战部', '共青团', '中央', '12345', '市民服务热线', '国务院', '部', '电视台', '电台', '小组', '人员', '市长', '书记', '负责人', '处长', '科长', '法官', '民警', '警察', '检察官', '律师', '院长', '校长', '局长', '主席', '主任', '村民', '居民', '领导', '人民代表', '人大代表', '复议', '警号', '大会', '信访', '仲裁', '诉讼'
]

export default {
  AntiStop
}
